<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title text-green"><i class="fas fa-search-plus"></i>  {{ "TITLE.SEARCH-OPTIONS" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-md-5">
        <label for="docNumberInput"
               class="font-weight-bold text-dark-light">{{ "LABEL.IDENTIFICATION-DOCUMENT-NUMBER" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-id-card"></i></div>
          </div>
          <input type="text"
                 id="docNumberInput"
                 placeholder="{{ 'MESSAGE.N-DOC-PARTICIPANT' | translate }}"
                 class="form-control form-control"
                 [(ngModel)]="searchDocument.documentNumber"
                 [ngbTooltip]="tipDocNumber">
        </div>
      </div>
      <div class="form-group col-md-7">
        <label for="fullNameInput"
               class="font-weight-bold text-dark-light">{{ "LABEL.NAMES-PARTICIPANT" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-user-check"></i></div>
          </div>
          <input type="text"
                 id="fullNameInput"
                 class="form-control form-control"
                 placeholder="{{ 'MESSAGE.NAMES-SURNAMES-PARTICIPANT' | translate }}"
                 [(ngModel)]="searchDocument.fullName"
                 [ngbTooltip]="tipFullName">
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-5">
        <label for="docNumberInput"
               class="font-weight-bold text-dark-light">{{ "LABEL.RUC-PARTICIPANT" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-id-card"></i></div>
          </div>
          <input type="text"
                 id="rucInput"
                 placeholder="{{ 'MESSAGE.RUC-PARTICIPANT' | translate }}"
                 class="form-control form-control"
                 [(ngModel)]="searchDocument.ruc"
                 [ngbTooltip]="tipRUC">
        </div>
      </div>
      <div class="form-group col-md-7">
        <label for="fullNameInput"
               class="font-weight-bold text-dark-light">{{ "LABEL.BUSINESS-NAME-PARTICIPANT" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-user-check"></i></div>
          </div>
          <input type="text"
                 id="businessNameInput"
                 class="form-control form-control"
                 placeholder="{{ 'MESSAGE.BUSINESS-NAME-PARTICIPANT' | translate }}"
                 [(ngModel)]="searchDocument.businessName"
                 [ngbTooltip]="tipBusinnesName">
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="fullNameUploader"
             class="font-weight-bold text-dark-light">{{ "MESSAGE.NAMES-PERSON-UPLOAD-DOCUMENT" | translate }}</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-chalkboard-teacher"></i></div>
        </div>
        <input type="text"
               id="fullNameUploader"
               class="form-control form-control"
               placeholder="{{ 'MESSAGE.NAMES-PERSON-UPLOAD-DOCUMENT' | translate }}"
               [(ngModel)]="searchDocument.uploader"
               [ngbTooltip]="tipUploader">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="dateFrom"
               class="font-weight-bold text-dark-light">{{ 'LABEL.FROM' | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-calendar-day"></i></div>
          </div>
          <input id="dateFrom"
                 class="form-control"
                 name="dp"
                 ngbDatepicker #d="ngbDatepicker"
                 placeholder="dd/mm/yyyy"
                 [(ngModel)]="searchDocument.dateFrom_"
                 [ngbTooltip]="tipDateFrom">
          <div class="input-group-append">
            <button class="btn btn-outline-success" (click)="d.toggle()" type="button">
              <i class="far fa-calendar-alt"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="form-group col-md-6">
        <label for="dateTo"
               class="font-weight-bold text-dark-light">{{ 'LABEL.TO' | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-calendar"></i></div>
          </div>
          <input id="dateTo"
                 class="form-control"
                 name="dp1"
                 ngbDatepicker #d1="ngbDatepicker"
                 placeholder="dd/mm/yyyy"
                 [(ngModel)]="searchDocument.dateTo_"
                 [ngbTooltip]="tipDateTo">
          <div class="input-group-append">
            <button class="btn btn-outline-success" (click)="d1.toggle()" type="button">
              <i class="far fa-calendar-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="search()"><i
      class="fa fa-search"> </i> {{ 'BUTTON.SEARCH' | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()"><i
      class="fa fa-times-circle"></i> {{ 'BUTTON.CANCEL' | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
<ng-template #tipUploader>{{ 'MESSAGE.NAMES-PERSON-UPLOAD-DOCUMENT' | translate }}</ng-template>
<ng-template #tipDateFrom>{{ 'MESSAGE.ESTABLISHES-MINIMUM-RANGE' | translate }}</ng-template>
<ng-template #tipDateTo>{{ 'MESSAGE.ESTABLISHES-MAXIMUM-RANGE' | translate }}</ng-template>
<ng-template #tipDocNumber>{{ 'MESSAGE.N-DOC-PARTICIPANT' | translate }}</ng-template>
<ng-template #tipFullName>{{ 'MESSAGE.NAMES-SURNAMES-PARTICIPANT' | translate }}</ng-template>
<ng-template #tipRUC>{{ 'MESSAGE.RUC-PARTICIPANT' | translate }}</ng-template>
<ng-template #tipBusinnesName>{{ 'MESSAGE.BUSINESS-NAME-PARTICIPANT' | translate }}</ng-template>

